module.exports = __webpack_public_path__ + "img/background complete.a5f8445b.svg";